export enum NEWS_AND_PREMIUM_CONTENT_SELECT_VALUE_KEYS {
  ID = 'id',
  NAME = 'name'
}
